import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { FetchError, GetWikiPageDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";
import { configuration } from "../../../configuration";

const useGetWikiPageRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getWikiPageRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.wiki.getWikiPage>>): Promise<GetWikiPageDto> {
    const accessToken = await getAccessToken();
    const [{ slug }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/wiki/${slug}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getWikiPageRequest };
};

const useGetWikiPage = (slug: string) => {
  const { getWikiPageRequest } = useGetWikiPageRequest();

  return useQuery({
    queryKey: queryKeys.wiki.getWikiPage(slug),
    queryFn: getWikiPageRequest,
  });
};

export { useGetWikiPage };
